import React from "react";
import { LineChart } from '@mui/x-charts/LineChart';

function XweeksYordini({
    data,
    titolo,
    displayTitolo,
    settings,
    colorMap
}) {


    let dataset = [];
    let keyToLabel = {};

    const questAnno = new Date().getFullYear()

    if (settings.series[questAnno]) {
        keyToLabel.current_year = questAnno;
    }

    if (settings.series[questAnno - 1]) {
        keyToLabel.year_minus_1 = questAnno - 1;
    }
    if (settings.series[questAnno - 2]) {
        keyToLabel.year_minus_2 = questAnno - 2;
    }
    if (settings.series[questAnno - 3]) {
        keyToLabel.year_minus_3 = questAnno - 3;
    }
    if (settings.series[questAnno - 4]) {
        keyToLabel.year_minus_4 = questAnno - 4;
    }
    if (settings.series[questAnno - 5]) {
        keyToLabel.year_minus_5 = questAnno - 5;
    }




    if (data.dataSet) {
        dataset = data.dataSet;
    }
    console.log("dataset", dataset)

    let mutantValueFormatter = (value) => value

    if (settings.robaDaSommare === 'ordini') {
        mutantValueFormatter = (value) => !value ? 0 : value
    } else if (settings.robaDaSommare === 'importo') {
        mutantValueFormatter = (value) => !value ? 0 : value.toString().replace('.', ',').replace(/\d(?=(?:(?:\d{3})+),)/g, match => `${match}.`) + " €";
    }   

    const colors = {
        current_year: 'yellow',
        year_minus_1: 'orange',
        year_minus_2: 'red',
        year_minus_3: 'lightgray',
        year_minus_4: 'gray',
        year_minus_5: 'black',
    };


    /* const stackStrategy = {
        stack: 'total',
        area: true,
        stackOffset: 'none', // To stack 0 on top of others
    }; */

    const customize = {
        height: 700,
        /* legend: { hidden: true }, */
        margin: { top: 5 },
        stackingOrder: 'descending'
    };

    let stackStrategy;

    if (settings.stack) {
        stackStrategy = {
            stack: 'total',
            area: true,
            stackOffset: 'none', // To stack 0 on top of others
            stackOrder: 'reverse'
        };
    }
    

    const series = Object.keys(keyToLabel).map((key) => {
        const anno = keyToLabel[key];
        const coloreLinea =
            (colorMap && colorMap[anno]) ||
            colors[key] ||
            "#000";

        return {
            dataKey: key,
            label: anno,
            valueFormatter: (v) => mutantValueFormatter(v),
            /* connectNulls: true, */
            color: coloreLinea,
            showMark: false,
            ...stackStrategy,
        };
    })


    



    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                <div className="pa2 flex flex-wrap items-center">
                    <LineChart
                        xAxis={[{
                            dataKey: 'week',
                            valueFormatter: (v) => "w"+(v+1)
                        }]}
                        series={series}
                        dataset={dataset}
                        {...customize}
                    />
                </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default XweeksYordini;
